import { Button, Card, Checkbox, Input, Tooltip } from 'antd';
import { TrashIcon } from '@phosphor-icons/react';
import { TagFamilyMemberType } from '../../../../../schemas/index';
import TagChildrenEditor from './TagChildrenEditor';
import { useAppSelector } from '../../../../../store/store';

function TagNodeEditor({
  node,
  path,
  onChange,
  onDelete,
  onAddChild,
  onSort,
  sortableHandle,
  level = 0,
}: {
  node: TagFamilyMemberType;
  path: Array<number>;
  onChange: (path: Array<number>, newNode: TagFamilyMemberType) => void;
  onDelete: (path: Array<number>) => void;
  onAddChild: (path: Array<number>, child: TagFamilyMemberType) => void;
  onSort: (path: Array<number>, newNodes: Array<TagFamilyMemberType>) => void;
  sortableHandle?: React.ReactNode;
  level?: number;
}) {
  const workflowPayload = useAppSelector(state => state.workflows.workflowCreatePayload);
  const isUpdateMode = Boolean(workflowPayload && 'id' in workflowPayload && workflowPayload.id);

  return (
    <Card
      style={{
        marginBottom: 8,
        minWidth: 'max-content',
        marginLeft: level * 12,
        background: 'transparent',
        borderRadius: 20,
        overflow: 'hidden',
      }}
      styles={{
        header: {
          overflowX: 'auto',
          overflowY: 'visible',
          padding: '8px 16px',
          background: '#ffffff',
        },
        body: {},
      }}
      title={
        <div
          style={{
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            minWidth: 'max-content',
            flexWrap: 'nowrap',
          }}
        >
          {sortableHandle}
          <Input
            placeholder="Label"
            variant="outlined"
            size="small"
            value={node.name}
            onChange={e => onChange(path, { ...node, name: e.target.value })}
            style={{ width: 160, minWidth: 160, flexShrink: 0 }}
          />
          <Input
            placeholder="Description"
            variant="outlined"
            size="small"
            value={node.description}
            onChange={e => onChange(path, { ...node, description: e.target.value })}
            style={{ width: 200, minWidth: 200, flexShrink: 0 }}
          />
          {(node.children?.length ?? 0) > 0 &&
            (isUpdateMode ? (
              <Tooltip title="Cannot change this in edit mode.">
                <Checkbox
                  checked={!!node.allowMultiple}
                  onChange={e => onChange(path, { ...node, allowMultiple: e.target.checked })}
                  style={{
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    fontWeight: 400,
                  }}
                  disabled
                >
                  Allow Multiple
                </Checkbox>
              </Tooltip>
            ) : (
              <Checkbox
                checked={!!node.allowMultiple}
                onChange={e => onChange(path, { ...node, allowMultiple: e.target.checked })}
                style={{ whiteSpace: 'nowrap', flexShrink: 0, fontWeight: 400 }}
              >
                Allow Multiple
              </Checkbox>
            ))}
          <Button
            icon={<TrashIcon />}
            type="text"
            danger
            size="small"
            onClick={() => onDelete(path)}
            style={{ flexShrink: 0, minWidth: 'auto' }}
          />
        </div>
      }
    >
      <TagChildrenEditor
        nodes={node.children || []}
        parentPath={path}
        onChange={onChange}
        onDelete={onDelete}
        onAddChild={onAddChild}
        onSort={onSort}
        level={level + 1}
      />
    </Card>
  );
}

export default TagNodeEditor;
